import { createAsyncThunk } from '@reduxjs/toolkit';
import store, { TRootState } from '../../../..';
import ApiaApi, { makeApiaUrl } from '../../../../../api/apiaApi/apiaApi';
import {
  TApiaFilterValue,
  TApiaFilterOption,
  TApiaFilter,
} from '../../../../../types';
import { arrayOrArray } from '../../../../../utils/util';
import { buttonsActions } from '../../../../buttonsSlice';

export type TNewFilterValues = {
  label: string;
  value: string;
  id?: string;
}[];

export type TNewFilter = {
  options: TNewFilterValues;
  id: string;
};
const loadFilters = createAsyncThunk<
  {
    newFilterId: TApiaFilterValue;
    newFilterOptions: TApiaFilterOption[];
  },
  {
    fieldId: string;
    triggerFilterId?: string;
    newFilterId: string;
    fromReasign?: boolean;
    txtProTitle?: TApiaFilterValue;
    triggerFilter?: TApiaFilter;
  },
  { state: TRootState }
>(
  'listSlice/loadFilters',
  async (
    {
      fieldId,
      triggerFilterId,
      newFilterId,
      fromReasign,
      txtProTitle,
      triggerFilter,
    },
    thunkApi,
  ) => {
    store.dispatch(
      buttonsActions.updateAction([
        {
          performing: true,
          action: 'disableTable',
        },
      ]),
    );

    const state = thunkApi.getState().listSlice.lists[fieldId];

    const payload: Record<string, unknown> = {
      action: 'loadTasksByProcess',
      fromReasign,
      txtProTitle,
    };
    if (triggerFilter) {
      payload.proId = triggerFilter?.options?.find((option) => {
        return option.value === triggerFilter.currentValue;
      })?.id;
    } else if (triggerFilterId) {
      payload.proId = state.filters?.[
        state.filters?.findIndex(
          (filter) => filter.id.toString() === triggerFilterId,
        )
      ]?.options?.find((option) => {
        return (
          option.value ===
          state.filters?.[
            state.filters?.findIndex((filter) => {
              return filter.id.toString() === triggerFilterId;
            })
          ].currentValue
        );
      })?.id;
    }

    const result = await ApiaApi.post<{
      task: { id: string; text: string } | { id: string; text: string }[];
    }>(
      makeApiaUrl({
        ...payload,
        isAjax: true,
      }),
    );

    if (result && result.data) {
      store.dispatch(
        buttonsActions.updateAction([
          {
            performing: false,
            action: 'disableTable',
          },
        ]),
      );

      if (result.data.task) {
        store.dispatch(
          buttonsActions.updateAction([
            {
              performing: false,
              action: 'disableTable',
            },
          ]),
        );

        const newOptions: TApiaFilterOption[] = [
          {
            selected: true,
            label: '',
            value: '',
            id: '',
          },
        ];
        arrayOrArray(result.data.task).forEach((option) => {
          newOptions.push({
            selected: false,
            label: option.text,
            value: option.text,
            id: option.id,
          });
        });
        return {
          newFilterId,
          newFilterOptions: newOptions,
        };
      }
    }
    store.dispatch(
      buttonsActions.updateAction([
        {
          performing: false,
          action: 'disableTable',
        },
      ]),
    );
    return {
      newFilterId,
      newFilterOptions: [],
    };
  },
);

export default loadFilters;
